module.exports = "<i class=\"fa fa-question-circle\" aria-hidden=\"true\" tooltip=\"{{text}}\"\n   placement=\"top\"></i>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/help-bubble/help-bubble.component.html
// module id = 840
// module chunks = 3